import {create} from 'zustand'
import {
  IComponent,
  ILimitComponent,
  ISection,
  ITemplateAnalytic,
} from '../../interfaces/Analytics/Analytics'
import {Active} from '@dnd-kit/core'
import {components} from '../../_metronic/assets/ts'

type ProgressState = {
  sections: ISection[] // Change the type to Record<string, Setting>
  activeAnalyticDND: Active | null
  components: IComponent[]
  iscomponentsLoading: boolean
  iscomponentCopyCase: boolean
  component?: IComponent
  section?: ISection
  showUpdateComponentModal: boolean
  showUpdateTemplateModal: boolean
  showDeleteComponentModal: boolean
  showInstallAnalyticDashboardModal:boolean,
  showDeleteTemplateModal: boolean
  issectionDragging: boolean
  showEditAccessTemplateModal: boolean
  templatesAnalytic: ITemplateAnalytic[]
  templateAnalytic?: ITemplateAnalytic
  limitComponentData: ILimitComponent
  showDetailTemplate: boolean
  setShowDetailTemplate: (showDetailTemplate: boolean) => void
  setActiveAnalyticDND: (activeAnalyticDND: Active | null) => void
  setLimitComponentData: (limitComponentData: ILimitComponent) => void
  setComponentsLoading: (iscomponentsLoading: boolean) => void
  setShowEditAccessTemplateModal: (show: boolean) => void
  setShowDeleteComponentModal: (show: boolean) => void
  setShowDeleteTemplateModal: (show: boolean) => void
  setShowUpdateComponentModal: (show: boolean) => void
  setShowUpdateTemplateModal: (show: boolean) => void
  setComponents: (components: IComponent[] | ((components: IComponent[]) => IComponent[])) => void
  setSections: (sections: ISection[] | ((sections: ISection[]) => ISection[])) => void
  setComponent: (component: IComponent) => void
  setSection: (section: ISection) => void
  setTemplatesAnalytic: (templatesAnalytic: ITemplateAnalytic[]) => void
  setTemplateAnalytic: (templatesAnalytic: ITemplateAnalytic) => void
  setIsComponentCopyCase: (iscomponentCopyCase: boolean) => void
  setSectionDragging: (issectionDragging: boolean) => void
  setShowInstallAnalyticDashboardModal: (showInstallAnalyticDashboardModal: boolean) => void
}

export const useAnalyticsStore = create<ProgressState>((set) => ({
  activeAnalyticDND: null,
  sections: [],
  components: [],
  templatesAnalytic: [],
  limitComponentData: {companyAmount: 0, componentAnalyticCount: 0, limitComponentAnalytic: 0},
  iscomponentsLoading: false,
  iscomponentCopyCase: false,
  showDeleteComponentModal: false,
  showEditAccessTemplateModal: false,
  showInstallAnalyticDashboardModal:false,
  showDeleteTemplateModal: false,
  showUpdateComponentModal: false,
  showUpdateTemplateModal: false,
  issectionDragging: false,
  setShowInstallAnalyticDashboardModal: (showInstallAnalyticDashboardModal) => {
    set({showInstallAnalyticDashboardModal})
  },
  showDetailTemplate: false,
  setShowDetailTemplate: (showDetailTemplate) => {
    set({showDetailTemplate})
  },
  setSectionDragging: (issectionDragging) => {
    set({issectionDragging})
  },
  setActiveAnalyticDND: (activeAnalyticDND) => {
    set({activeAnalyticDND})
  },
  setLimitComponentData: (limitComponentData) => {
    set({limitComponentData})
  },
  setComponentsLoading: (iscomponentsLoading) => {
    set({iscomponentsLoading})
  },
  setShowUpdateComponentModal: (showUpdateComponentModal) => {
    set({showUpdateComponentModal})
  },
  setShowUpdateTemplateModal: (showUpdateTemplateModal) => {
    set({showUpdateTemplateModal})
  },
  setShowEditAccessTemplateModal: (showEditAccessTemplateModal) => {
    set({showEditAccessTemplateModal})
  },
  setTemplatesAnalytic: (templatesAnalytic) => {
    set({templatesAnalytic})
  },
  setTemplateAnalytic: (templateAnalytic) => {
    set({templateAnalytic})
  },
  setIsComponentCopyCase: (iscomponentCopyCase) => {
    set({iscomponentCopyCase})
  },
  component: undefined,
  section: undefined,
  setSections: (sections: ISection[] | ((sections: ISection[]) => ISection[])) => {
    if (typeof sections === 'function') {
      set((state) => ({
        sections: sections(state.sections).map((section) => ({
          ...section,
          id: section.sectionId,
        })),
      }))
    } else {
      const updatedSections = sections.map((section) => ({
        ...section,
        id: section.sectionId,
      }))

      set({sections: updatedSections})
    }
  },
  setComponents: (components: IComponent[] | ((components: IComponent[]) => IComponent[])) => {
    if (typeof components === 'function') {
      set((state) => ({
        components: components(state.components).map((component) => ({
          ...component,
          id: component.componentId,
        })),
      }))
    } else {
      const updatedComponents = components.map((component) => ({
        ...component,
        id: component.componentId,
      }))

      set({components: updatedComponents})
    }
  },
  setComponent: (component) => {
    set({component})
  },
  setSection: (section) => {
    set({section})
  },
  setShowDeleteComponentModal: (showDeleteComponentModal: boolean) => {
    set({showDeleteComponentModal})
  },
  setShowDeleteTemplateModal: (showDeleteTemplateModal: boolean) => {
    set({showDeleteTemplateModal})
  },
}))
